var paragraph_default = {
  "fontElementMap": "S7QiZ",
  "elementSpacing": "cFdAL",
  "text": "wHDUb cFdAL",
  "child": "UR7ou"
};
export {
  paragraph_default as default
};
//# sourceMappingURL=paragraph-scss.js.map
